module.exports = __webpack_public_path__ + "static/media/appnameNegative.b21d2c9d.png";